// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"tn-z","breadcrumbForward":"un-z","breadcrumbBack":"vn-z","selected":"wn-z"};